<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <!-- <div class="info_img">
      <img src="@/assets/newMedal/publicWelfare/bg2.png" alt="" />
    </div> -->
    <div class="info_img" v-if="userinfo.image">
      <img :src="imgUrl + userinfo?.image" alt="" />
    </div>
    <div class="info_img" v-else>
      <img src="@/assets/newMedal/publicWelfare/bg2.png" alt="" />
    </div>
    <div class="form">
      <div class="fild_label">
        <span>*</span>
        <div>姓名</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.nickname"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>部门</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.position"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>工号</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.empNo"
          placeholder="请输入员工姓名"
          disabled
        />
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>活动开始时间</div>
      </div>
      <div class="fild_value">
        <van-field disabled name="datetimePicker" :value="baseinfo.startTime" />
      </div>
      <div class="fild_label">
        <span>*</span>
        <div>活动结束时间</div>
      </div>
      <div class="fild_value">
        <van-field disabled name="datetimePicker" :value="baseinfo.endTime" />
      </div>
      <div class="fild_label">
        <span></span>
        <div>活动剩余名额</div>
      </div>
      <div class="fild_value">
        <van-field
          v-model="baseinfo.remaining"
          placeholder="请输入活动剩余名额"
          disabled
        />
      </div>
    </div>
    <div class="footer">
      <el-button class="btn1" @click="submit">确认</el-button>
      <el-button class="btn2" @click="no">取消</el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/publicWelfare";
import apis from "@/apis/medal";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      baseinfo: {
        nickname: "",
        empNo: "",
        position: "",
        enterTime: "",
        startTime: "",
        endTime:'',
        remaining: "",
        activityId: "",
      },
      showPicker: false,
      showPickerTwo: false,
      currentDate: new Date(),
      currentDateTwo: moment(new Date()).format("HH:mm"),
      userinfo: {},
      imgUrl: "",
    };
  },
  created() {},
  mounted() {
    this.imgUrl = apis.imgUrl;
    const { nickname, username, position } = this.$store.state.userInfo;
    this.baseinfo.nickname = nickname;
    this.baseinfo.empNo = username;
    this.baseinfo.position = position;

    const { itemUrl } = this.$route.query;
    this.userinfo = JSON.parse(itemUrl);
    this.baseinfo.activityId = this.userinfo.id;
    this.baseinfo.remaining = this.userinfo.num - this.userinfo.applyNum;
    this.baseinfo.startTime = moment(this.userinfo.startTime).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.baseinfo.endTime = moment(this.userinfo.endTime).format(
      "YYYY-MM-DD HH:mm:ss"
    )
    // this.baseinfo.startTime =
    //   moment(this.userinfo.startTime).format("HH:mm") +
    //   "—" +
    //   moment(this.userinfo.endTime).format("HH:mm");
  },
  methods: {
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    //确认时间
    onConfirm(time) {
      this.baseinfo.enterTime = moment(time).format("YYYY-MM-DD");
      this.showPicker = false;
    },
    //确认时间2
    onConfirmTwo(time) {
      console.log(time, "time");

      this.baseinfo.startTime = time;
      this.showPickerTwo = false;
    },
    //提交报名
    submit() {
      const params = {
        activityId: this.baseinfo.activityId,
        empNo: this.baseinfo.empNo,
        type:'1'
      }
      api.apply(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "报名成功",
            type: "success",
          });
          this.$router.go(-1);
        }
      })
    },
    //取消报名
    no() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .info_img {
    width: 100%;
    height: 120px * $zoom;
    img {
      width: 100%;
      height: 100%;
      border-radius: 40px;
    }
  }
  .form {
    width: 100%;
    background: #fff;
    border-radius: 25px;
    padding: 30px;
    margin-top: 20px;
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 26px;
      }
    }
    .fild_value {
      width: 100%;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
      img {
        margin-left: 20px;
        width: 55px;
        height: 55px;
      }
    }
  }
}
.footer {
  .btn2 {
    border: none;
    background: none;
    color: #969b9e;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 0 0 30px !important;
    border-radius: 15px;
  }
  .btn1 {
    border: 1px solid #1fbe8a;
    background: #1fbe8a;
    color: #fff;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px;
    border-radius: 15px;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
</style>
